import { createContext } from 'react'

const CurrentBpContext = createContext()

export default CurrentBpContext
